import { atom } from "recoil";

export const compareState = atom({
  key: "compareState", // Unique key for this atom
  default:  [],
});
//
